export default function SectionApp() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500/5 to-accent-500/5 rounded-2xl border border-background-300/30 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-4">
              <i className="ri-smartphone-line text-primary-400 text-sm"></i>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">多端同步</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">移动端体验</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-lg leading-relaxed">
              91精品影视全面适配手机、平板等移动设备。无论您身在何处，打开浏览器即可畅享高清在线看片体验。无需下载APP，不占内存不缓存垃圾，即开即看的便捷观影方式。
            </p>
            <div className="flex flex-wrap gap-6 mt-6 justify-center lg:justify-start">
              {[
                { icon: 'ri-checkbox-circle-line', text: '即开即看' },
                { icon: 'ri-checkbox-circle-line', text: '高清流畅' },
                { icon: 'ri-checkbox-circle-line', text: '省电省流量' },
              ].map((f) => (
                <div key={f.text} className="flex items-center gap-2">
                  <i className={`${f.icon} text-primary-400 text-sm`}></i>
                  <span className="text-xs text-foreground-300 whitespace-nowrap">{f.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-48 h-80 sm:w-56 sm:h-96 rounded-2xl overflow-hidden border-2 border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimal%20mobile%20phone%20mockup%20showing%20a%20dark%20themed%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20in%20a%20grid%20layout%2C%20warm%20golden%20and%20crimson%20accent%20colors%2C%20modern%20UI%20design%2C%20phone%20frame%20visible%2C%20dark%20background%2C%20premium%20aesthetic&width=480&height=854&seq=app-mobile-mockup&orientation=portrait"
                alt="91精品影视移动端体验"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}